import { render, staticRenderFns } from "./schedulepos.vue?vue&type=template&id=96ad5fe4"
import script from "./schedulepos.vue?vue&type=script&lang=js"
export * from "./schedulepos.vue?vue&type=script&lang=js"
import style0 from "./schedulepos.vue?vue&type=style&index=0&id=96ad5fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports